import mAxios from '@/axios';
import { uniqBy, sortBy } from 'lodash';

// Helper function to build demo URLs and handle parameter validation
function buildDemoUrl(basePath, param) {
  if (!param) return Promise.resolve({ data: [] });
  return `/api/v1/analytics/demo/${basePath}-${param}`;
}

export default {
  async fetchAnalyticsFilters({commit}, data) {
    const request = new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/filters', { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

    const result = await request;

    commit('MUTATE_FILTERS', result);
  },
  async fetchAnalyticsFiltersSearch({commit}, data) {
    const request = new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/filters-search', { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

    const result = await request;

    commit('MUTATE_FILTERS', result);
  },
  async fetchAnalyticsFiltersSearchClinic({commit}, data) {
    const request = new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/filter-clinic', { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

    const result = await request;

    commit('MUTATE_FILTERS', result);
  },
  async fetchAnalyticsFiltersSearchClinicNurse({commit}, data) {
    const request = new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/filter-clinic-nurse', { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

    const result = await request;

    commit('MUTATE_FILTERS', result);
  },
  async fetchFilterByState({commit}, data) {
    const request = new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/filter-by-state', { params: { ...data.params } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });

    const response = await request;
    let result = {
      from: 'collection',
    };

    if (data.type === 'both') {
      result = {
        ...result,
        postCode: sortBy(uniqBy(response.data.data[0].docs, 'postCode'), ['postCode']),
        suburb: sortBy(uniqBy(response.data.data[0].docs, 'suburb'), ['suburb']),
      };
    } else if (data.type === 'search') {
      result = {
        ...result,
        suburb: sortBy(uniqBy(response.data.data[0].docs, 'suburb'), ['suburb']),
      };

      if (data.params.postCode) {
        result = {
          ...result,
          postCode: sortBy(uniqBy(response.data.data[0].docs, 'postCode'), ['postCode']),
        };
      }
    } else {
      result = {
        ...result,
        suburb: response.data.data[0].docs,
      };
    }

    commit('MUTATE_FILTERS', {
      data: result,
    });
  },
  fetchClinicState(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/filter-clinic', { params: data })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchTreatmentAreas(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/treatment-areas', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchTreatmentAreasAge(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/treatment-areas-age', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchTreatmentAreasArea(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/treatment-areas-area', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchTreatmentAreasAgeGender(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/treatment-areas-age-gender', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchTreatmentAreasByBrand(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/treatment-areas-by-brand', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchTreatmentsPerWeek(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/treatment-areas-per-week', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchBrands(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/brands', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchBrandsAverageByArea(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/brands-average-by-area', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchSingleVsMultipleTreatment(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/treatment-areas-single-multiple', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchActiveInactiveClinics(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/active-inactive-clinics', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchActiveNurses(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/active-nurses', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchLastAppointments(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/last-appointments', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchAppointmentNotes(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/appointments-with-without-notes', {
          params: { ...data },
        })
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  fetchPatientTrend(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get(`/api/v1/analytics/patient-trends-${data.type}`, { params: { ...data.params } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchOvertime(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/overtime', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformanceCurrentNumberOfPatients(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-current-num-patients', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformanceCurrentNumberOfAppointments(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-current-num-appointments', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformanceCurrentNumberOfProductPurchases(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-product-purchases-in-last-30-days', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformanceTreatmentVolume(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-volume-of-treatments-by-treatment-area-by-nurse', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformancePatientCount(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-new-vs-returning-patient-count', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformanceProductPurchasesData(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-annual-product-purchases', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformanceTopTreatmentAreas(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-top-5-treatment-areas', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformanceTreatmentTypeCount(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-treatment-type-count', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPerformanceSpidergram(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-performance-spidergram', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  // Clinic Performance Dashboard V2 routes
  fetchClinicCurrentNumberPatients(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-number-of-appointments';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/number-of-appointments';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicCurrentNumberAppointments(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-number-of-appointments-vs-top-performers';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/number-of-appointments-per-month';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicMixPatientsCount(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-mix-patients-count';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/mix-patients';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicProductPurchasesLast30Days(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-dashboard-v2-product-purchases-in-last-30-days', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicVolumeTreatmentsByTreatmentAreaByNurse(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-dashboard-v2-volume-of-treatments-by-treatment-area-by-nurse', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicAnnualProductPurchases(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-dashboard-v2-annual-product-purchases', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicTop5TreatmentAreas(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-dashboard-v2-top-5-treatment-areas', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicTreatmentTypeCount(_context, data) {
    return new Promise((resolve, reject) => {
      mAxios
        .get('/api/v1/analytics/clinic-dashboard-v2-treatment-mix-with-top-performers', { params: { ...data } })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicTreatmentMix(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-treatment-mix';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/treatment-mix-your-clinic';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicInjectablesSpend(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-injectables-spend';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/injectables-spend';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicNumberOfClientsNotBooked(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-number-of-clients-not-booked';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/number-of-patients-not-booked';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicAppointmentVolumes(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-appointment-volume';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/appointment-volume';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicProductVolumes(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-product-volume';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/product-volume';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicProductMix(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-product-mix-by-spend';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/product-mix-by-spend';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPatientCount(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-number-of-patients';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/number-of-patients';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicPatientDemographics(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-patient-demographics';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/patient-demographics';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicAvgAppointmentsPerDay(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-average-appointments-per-day-vs-top-performers';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/avg-appointments-per-day';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicTimeBetweenAppointments(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-time-between-appointments';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      const treatmentType = data['treatment_type'];
      const demoUrl = buildDemoUrl('time-between-appointments', treatmentType);
      if (typeof demoUrl === 'object') {
        return demoUrl; // Promise.resolve({ data: [] })
      }
      url = demoUrl;
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicAvgTreatmentsPerAppointment(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-average-treatments-per-appointment';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      const treatmentType = data['treatment_type'];
      const demoUrl = buildDemoUrl('avg-treatments-per-appointment', treatmentType);
      if (typeof demoUrl === 'object') {
        return demoUrl; // Promise.resolve({ data: [] })
      }
      url = demoUrl;
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicProductPurchases(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-product-purchases';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/product-purchases';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicProductSpendBreakdowns(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-product-spend-breakdown';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/product-spend-breakdown';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicProductDosageTrends(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-product-dosage-trends';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      const product = data['product'] && data['product'][0];
      const demoUrl = buildDemoUrl('product-dosage-trends', product);
      if (typeof demoUrl === 'object') {
        return demoUrl; // Promise.resolve({ data: [] })
      }
      url = demoUrl;
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicProductFilter(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-filter-products';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      url = '/api/v1/analytics/demo/filter-products';
      params = {};
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicComparisonConfigDefaults(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-comparison-config-defaults';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      return Promise.resolve({});
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicNumberOfAppointmentsVsComparableClinics(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-number-of-appointments-vs-comparable-clinics';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      return Promise.resolve([]);
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicProductDosageTrendsComparableClinics(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-product-dosage-trends-comparable-clinics';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      return Promise.resolve([]);
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicAvgAppointmentsPerDayVsComparableClinics(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-average-appointments-per-day-vs-comparable-clinics';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      return Promise.resolve([]);
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  fetchClinicAvgTreatmentsPerAppointmentComparableClinics(_context, data) {

    let url = '/api/v1/analytics/clinic-dashboard-v2-average-treatments-per-appointment-comparable-clinics';
    let params = { ...data };

    const isDemo = data['demo'];

    if (isDemo) {
      return Promise.resolve([]);
    }

    return new Promise((resolve, reject) => {
      mAxios
        .get(url, { params: params })
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
};
